import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subscription, BehaviorSubject } from "rxjs";
import { ReportNote } from "../../models/compliance.model";
import { AuthService } from "../../../services/auth.service";
import { NoteType } from '../../../common/models/note-type.enum';
import { IssuesService } from "../../../common/services/issues.service";

@Component({
    selector: 'report-notes',
    templateUrl: './report-notes.component.html',
    styleUrls: ['./report-notes.component.scss', '../../../common/components/notes/notes.component.scss'],
    standalone: false
})
export class ReportNotesComponent implements OnInit, OnDestroy {

    form: FormGroup;

    private _notes: ReportNote[];

    get disableSave(): boolean {
        if (this.form == null) return false;
        const contentCtrl = this.form.get("content");
        if (contentCtrl == null) return false;
        return contentCtrl.invalid || this.savingNote.value;
    }
    @Input() enabled: boolean = true;
    @Output() errorOccurred: EventEmitter<any> = new EventEmitter<any>();
    @Input() label: string = "Notes";

    get notes(): ReportNote[] {
        return this._notes;
    }

    @Input() set notes(data: ReportNote[]) {
        data = data.sort((a, b) => {
            if (a.createdDate < b.createdDate) return -1;
            if (b.createdDate < a.createdDate) return 1;
            return 0;
        });
        this._notes = data;
    }

    @Output() noteAdded: EventEmitter<ReportNote> = new EventEmitter<ReportNote>();
    @Output() noteDeleted: EventEmitter<number> = new EventEmitter<number>();

    noteType = NoteType;

    pendingNote: ReportNote;

    @Input() reportId: string;

    savingNote: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    subscription: Subscription = new Subscription;

    constructor(private auth: AuthService) { }

    ngOnInit() {

    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }


    addNote(): void {
        this.pendingNote = {
            createdByName: this.auth.User.displayName,
            createdByUserId: this.auth.User.id,
            reportId: this.reportId,
            text: "",
            createdDate: (new Date()).toUTCString(),
            type: NoteType.Internal
        } as ReportNote;
    }

    cancel(): void {
        this.pendingNote = null;
    }

    deleteNote(index: number): void {
        this.noteDeleted.emit(index);
    }

    editorFormBuilt(group: FormGroup): void {
        this.form = group;
    }

    getNoteDate(note: ReportNote): string {
        const date = new Date(note.createdDate);
        return date.toLocaleDateString();
    }

    submitNote(): void {
        this.pendingNote.createdDate = (new Date()).toUTCString();
        this.pendingNote.text = this.form.get("content").value;
        this.noteAdded.emit(this.pendingNote);
        this.pendingNote = null;       
    }

    throwError(err: any): void {
        this.errorOccurred.emit(err);
    }
}
